<div class="page">
    <app-page-header titulo="Histórico" icono="bi-archive-fill" seccion="historico"
        descripcion="Relaciones entre personas, asociaciones y cargos por ejercicio. Busca a una persona para consultar sus relaciones."></app-page-header>

    <section class="panel" aria-labelledby="historico-persona">
        <h2 id="historico-persona" class="panel__title">Persona</h2>
        @if (asociadoSelected) {
            <div class="persona-seleccionada" data-testid="asociado-seleccionado">
                <div class="persona-seleccionada__id">
                    <span class="avatar-lg" aria-hidden="true"><i class="bi bi-person-fill"></i></span>
                    <div>
                        <span class="h5 mb-0 d-block">{{ nombreCompleto(asociadoSelected) }}</span>
                        <a class="small" [routerLink]="['/asociados', asociadoSelected.id]" data-testid="ver-ficha">Ver ficha</a>
                    </div>
                </div>
                <div class="cluster">
                    <a class="btn btn-outline-secondary btn-sm" [routerLink]="['/asociados', asociadoSelected.id, 'historico']" data-testid="editar-historico"><i class="bi bi-pencil-square" aria-hidden="true"></i>Editar histórico</a>
                    @if (puedeEscribir) {
                        <a class="btn btn-outline-primary btn-sm" [routerLink]="['/historico/lote']" [queryParams]="{ asociado: asociadoSelected.id }" data-testid="asignar-varios"><i class="bi bi-collection" aria-hidden="true"></i>Asignar a varios ejercicios</a>
                    }
                    <button type="button" class="btn btn-outline-secondary btn-sm" data-testid="cambiar-asociado" (click)="cambiarAsociado()"><i class="bi bi-arrow-repeat" aria-hidden="true"></i>Cambiar asociado</button>
                </div>
            </div>
        } @else {
            <label for="username" class="form-label">NIF del usuario (o busca por nombre, apellidos)</label>
            <div class="buscador-fila">
                <div class="flex-grow-1">
                    <app-asociado-buscador inputId="username" [control]="user" [minCaracteres]="3" placeholder="NIF, nombre o apellidos" (elegido)="seleccionar($event)" (buscarExacto)="loadDataUser()"></app-asociado-buscador>
                </div>
                <button type="button" class="btn btn-primary" aria-label="Buscar asociado" (click)="loadDataUser()"><i class="bi bi-search" aria-hidden="true"></i>Buscar</button>
            </div>
            @if (errorAsociado) { <div class="field-error" role="alert" data-testid="error-asociado">{{ errorAsociado }}</div> }
            @if (puedeEscribir) {
                <div class="mt-3"><a class="btn btn-outline-primary btn-sm" routerLink="/historico/lote" data-testid="asignar-sin-asociado"><i class="bi bi-collection" aria-hidden="true"></i>Asignar un cargo a varios ejercicios</a></div>
            }
        }
    </section>

    @if (loadingData) {
        <app-spinner [fullscreen]="false"></app-spinner>
    } @else if (asociadoSelected) {
        <section class="panel" aria-labelledby="historico-filtros">
            <h2 id="historico-filtros" class="panel__title">Filtros</h2>
            <div class="toolbar" data-testid="filtros">
                <div>
                    <label class="form-label" for="h-ejercicio">Ejercicio</label>
                    <select id="h-ejercicio" class="form-select" data-testid="filtro-ejercicio" [(ngModel)]="ejercicio" (ngModelChange)="reiniciar()">
                        <option value="">Todos</option>
                        @for (e of ejercicios; track e.id) { <option [ngValue]="e.id">{{ e.anyo }}@if (e.vigente) { (vigente) }</option> }
                    </select>
                </div>
                <div>
                    <label class="form-label" for="h-asociacion">Asociación</label>
                    <select id="h-asociacion" class="form-select" data-testid="filtro-asociacion" [(ngModel)]="asociacion" (ngModelChange)="reiniciar()">
                        <option value="">Todas</option>
                        @for (a of asociaciones; track a.id) { <option [ngValue]="a.id">{{ a.nombre }}</option> }
                    </select>
                </div>
                <div>
                    <label class="form-label" for="h-cargo">Cargo</label>
                    <select id="h-cargo" class="form-select" data-testid="filtro-cargo" [(ngModel)]="cargo" (ngModelChange)="reiniciar()">
                        <option value="">Todos</option>
                        @for (c of cargos; track c.id) { <option [ngValue]="c.id">{{ c.nombre }}{{ c.esInfantil ? ' (infantil)' : '' }}</option> }
                    </select>
                </div>
                <div>
                    <label class="form-label" for="h-tipo">Tipo</label>
                    <select id="h-tipo" class="form-select" data-testid="filtro-tipo" [(ngModel)]="tipo" (ngModelChange)="reiniciar()">
                        <option value="">Todos</option>
                        @for (t of TIPOS; track t.id) { <option [ngValue]="t.id">{{ t.texto }}</option> }
                    </select>
                </div>
                <div>
                    <label class="form-label" for="h-estado">Estado</label>
                    <select id="h-estado" class="form-select" data-testid="filtro-estado" [(ngModel)]="estado" (ngModelChange)="reiniciar()">
                        @for (e of ESTADOS; track e.id) { <option [ngValue]="e.id">{{ e.texto }}</option> }
                    </select>
                </div>
            </div>
        </section>

        <div class="toolbar-summary">
            <p aria-live="polite" data-testid="resumen">
                @if (cargando) { Buscando… } @else if (resultado) {
                    @if (total) { <strong>{{ total }}</strong> relación(es) · mostrando {{ desde }}–{{ hasta }} } @else { 0 relaciones }
                }
            </p>
            <div class="cluster">
                @if (hayFiltros) { <button type="button" class="btn btn-outline-secondary btn-sm" data-testid="limpiar" (click)="limpiarFiltros()"><i class="bi bi-x-circle" aria-hidden="true"></i>Limpiar filtros</button> }
                <button type="button" class="btn btn-outline-secondary btn-sm" data-testid="orden" (click)="alternarOrden()">
                    <i class="bi bi-arrow-down-up" aria-hidden="true"></i>{{ dir === 'desc' ? 'Más recientes primero' : 'Más antiguos primero' }}
                </button>
                <select class="form-select form-select-sm w-auto" aria-label="Por página" data-testid="tamano-pagina" [(ngModel)]="pageSize" (ngModelChange)="reiniciar()">
                    @for (t of TAMANOS; track t) { <option [ngValue]="t">{{ t }} por página</option> }
                </select>
            </div>
        </div>

        @if (error) {
            <div class="state-panel state-panel--error mb-3" role="alert" data-testid="error">
                <i class="bi bi-wifi-off state-panel__icon" aria-hidden="true"></i>
                <p class="state-panel__text">{{ error }}</p>
                <button type="button" class="btn btn-outline-danger btn-sm" data-testid="reintentar" (click)="reintentar()"><i class="bi bi-arrow-clockwise" aria-hidden="true"></i>Reintentar</button>
            </div>
        }
        <section class="panel panel--flush results-area" aria-label="Relaciones del histórico">
            @if (cargando) {
                <div class="progress results-progress" role="progressbar" aria-label="Cargando" data-testid="cargando">
                    <div class="progress-bar progress-bar-striped progress-bar-animated w-100"></div>
                </div>
            }
            <div class="table-wrap" [class.is-loading]="cargando" tabindex="0" role="region" aria-label="Tabla del histórico (desplazable)">
                <table class="table table-hover align-middle table-stack" data-testid="tabla">
                    <thead>
                        <tr><th scope="col">Ejercicio</th><th scope="col">Asociación</th><th scope="col">Cargo</th><th scope="col">Tipo</th><th scope="col">Estado</th><th scope="col"><span class="visually-hidden">Acciones</span></th></tr>
                    </thead>
                    <tbody>
                        @for (r of resultado?.historico ?? []; track r.idAsociacion + '-' + r.idCargo + '-' + r.idEjercicio + '-' + r.idTipoHistorico) {
                            <tr data-testid="fila">
                                <td data-label="Ejercicio">{{ r.anyoEjercicio }}@if (r.ejercicioVigente) { <span class="badge text-bg-primary ms-1">vigente</span> }</td>
                                <td data-label="Asociación"><a [routerLink]="['/asociaciones', r.idAsociacion]">{{ r.nombreAsociacion }}</a></td>
                                <td data-label="Cargo">{{ r.cargo }}@if (r.esInfantil) { <small class="text-muted"> (infantil)</small> }</td>
                                <td data-label="Tipo">{{ r.tipo }}</td>
                                <td data-label="Estado"><span class="badge" [ngClass]="ETIQUETA[r.estado].clase" [title]="ETIQUETA[r.estado].ayuda">{{ ETIQUETA[r.estado].texto }}</span></td>
                                <td data-label="" class="text-end">
                                    @if (puedeEscribir) {
                                        <a class="btn btn-outline-secondary btn-sm" data-testid="editar-fila" [routerLink]="['/asociados', r.idAsociado, 'historico']"
                                            [queryParams]="{ editar: r.idAsociacion + '_' + r.idCargo + '_' + r.idEjercicio }"><i class="bi bi-pencil-square" aria-hidden="true"></i>Editar</a>
                                    }
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
            @if (!cargando && !error && resultado && !resultado.historico.length) {
                <p class="empty-inline" data-testid="sin-resultados">
                    No hay relaciones en el histórico@if (hayFiltros) { con esos filtros }.
                </p>
            }
        </section>
        @if (totalPaginas > 1) {
            <nav class="pager" aria-label="Paginación del histórico">
                <button type="button" class="btn btn-outline-secondary btn-sm" data-testid="anterior" [disabled]="pagina <= 1 || cargando" (click)="irA(pagina - 1)"><i class="bi bi-chevron-left" aria-hidden="true"></i>Anterior</button>
                <span data-testid="pagina">Página {{ pagina }} de {{ totalPaginas }}</span>
                <button type="button" class="btn btn-outline-secondary btn-sm" data-testid="siguiente" [disabled]="pagina >= totalPaginas || cargando" (click)="irA(pagina + 1)">Siguiente<i class="bi bi-chevron-right" aria-hidden="true"></i></button>
            </nav>
        }
    }
</div>
